export default __webpack_public_path__ + "static/media/water_600ml.bf7ff39a.jpg";